import React from 'react';
import PropTypes from 'prop-types';
import SelectDropdown from '../select-dropdown';
import Pager from './pager';
import { createPortal } from 'react-dom';

const Pagination = props => {
  const options = props.itemsPerPageOptions
    ?.split?.(',')
    ?.map?.(p => ({ label: p, value: p }));
  const value = { label: props.itemsPerPage, value: props.itemsPerPage };
  const propsSelectDropdown = {
    fieldLabel: props.labelItemsPerPage,
    isLoading: false,
    options,
    value,
    className: 'pagination__items-per-page react-select',
    onChange: args => props.onItemsPerPageChange(args.value)
  };
  const portal =
    !!props.externalPerPageContainerId &&
    document.getElementById(props.externalPerPageContainerId);
  const itemsPerPage = <SelectDropdown {...propsSelectDropdown} />;

  return (
    <div className="pagination">
      {props?.total >= 2 ? <Pager {...props} /> : null}
      {!props.hideInlinePerPage && itemsPerPage}
      {portal && createPortal(itemsPerPage, portal)}
    </div>
  );
};

Pagination.propTypes = {
  labelItemsPerPage: PropTypes.string.isRequired,
  itemsPerPageOptions: PropTypes.string.isRequired,
  itemsPerPage: PropTypes.string.isRequired
};

export default Pagination;
